export default "__VITE_ASSET__a767b6cb__"